import { derived, writable } from 'svelte/store';
import { preload } from "../utils";

export const images = writable([]);
export const setImages = list => {
  list.forEach(image => preload(image, 'small'));
  images.update(() => list);
};

export const currentIndex = writable(0);
export const setCurrentIndex = index => currentIndex.update(() => index);

export const currentImage = derived([images, currentIndex], ([$images, $currentIndex]) => {
  return $images[$currentIndex];
});
